let links = {
  facebookEveniment: "https://www.facebook.com/EESTEC.Olympics/",
  facebookStand: "https://www.facebook.com/events/2239091659647147/",
  facebookEESTEC: "https://www.facebook.com/EESTEC.Bucuresti/",
  linkedInEESTEC: "https://www.linkedin.com/company/450726/",
  youtubeEESTEC: "https://www.youtube.com/user/eeStecBucuresti",
  instagramEESTEC: "https://www.instagram.com/eestec_lc_bucharest/",
  telefon: "0726 179 864",
  location: "https://goo.gl/maps/bDYp14rVU3q",
  mail: "eestec@office.ro",
  mailClick: "mailto:eestec@eestec.ro"
}

export default links;